/**
 * @prettier
 */
function filterUnique(list) {
  return list.filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
}

function concat(a, b) {
  return a.concat(b);
}

function flatMap(initialArray, callback) {
  return initialArray.map(callback).reduce(concat, []);
}

module.exports = {
  flatMap:  flatMap,
  filterUnique: filterUnique
}
